import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const FILE_ASPECT_RULE_EDITOR_CLASS_NAME = 'FileAspectRuleEditor';
export const FILE_ASPECT_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type FileAspectRuleEditorClassSlot =
	(typeof FILE_ASPECT_RULE_EDITOR_CLASS_SLOTS)[number];

export interface FileAspectRuleEditorClasses {
	root: string;
}

export type FileAspectRuleEditorClassKey = keyof FileAspectRuleEditorClasses;

export const getFileAspectRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(FILE_ASPECT_RULE_EDITOR_CLASS_NAME, slot);

export const fileAspectRuleEditorClasses: FileAspectRuleEditorClasses =
	generateUtilityClasses(FILE_ASPECT_RULE_EDITOR_CLASS_NAME, ['root']);

export default fileAspectRuleEditorClasses;
